import TopBar from './components/TopBar';
import Hero from './components/Hero';
import HotRank from './components/HotRank';
import FeedGrid from './components/FeedGrid';
import CategoryColumns from './components/CategoryColumns';
import TruthVault from './components/TruthVault';
import Timeline from './components/Timeline';
import TagCloud from './components/TagCloud';
import SubmitBanner from './components/SubmitBanner';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <TopBar />
      <main>
        <Hero />
        <HotRank />
        <FeedGrid />
        <CategoryColumns />
        <TruthVault />
        <Timeline />
        <TagCloud />
        <SubmitBanner />
      </main>
      <SiteFooter />
    </div>
  );
}